
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kajlgjzkiwuiklagwqgo.supabase.co';
const supabaseAnonKey = 'sb_publishable_56c7b9QU4Epz8ssAHeEJsQ_66_FoXVe';

/**
 * World-class Supabase client initialization.
 * Note: Key provided by user is utilized here. 
 * Standard Supabase schema assumption: 
 * 'profiles' table with columns: id (uuid, pk), full_name (text), role (text)
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
